import GradeList from "../components/common/GradeList/Index";
import LevelList from "../components/common/LevelList/Index";
import Layout from "../components/layout";
import { Panel } from "primereact/panel";

const LevelGrade = ({}) => {
  return (
    <Layout>
      <Panel header="Level">
        <LevelList className="m-0" />
      </Panel>
      <Panel header="Grade">
        <GradeList className="m-0" />
      </Panel>
    </Layout>
  );
};

export default LevelGrade;
